import {gql} from '@apollo/client';

export type DspComplaintHistoryTab = 'APPEAL_APPROVED' | 'APPEAL_REJECTED' | 'ACKNOWLEDGED';

export const MARK_DSP_COMPLAINT_HISTORY_TAB_AS_READ = gql`
    mutation MarkDspComplaintHistoryTabAsRead(
        $dspId: Long!,
        $warehouseId: Long!,
        $tab: DspComplaintHistoryTab!
    ) {
        markDspComplaintHistoryTabAsRead(
            dspId: $dspId,
            warehouseId: $warehouseId,
            tab: $tab,
        )
    }
`;

export interface MarkDspComplaintHistoryTabAsReadResponse {
    markDspComplaintHistoryTabAsRead: boolean;
}

export interface MarkDspComplaintHistoryTabAsReadVariables {
    dspId: number;
    warehouseId: number;
    tab: DspComplaintHistoryTab;
}
